import { all, takeEvery } from 'redux-saga/effects'

import { UpgradePlanActions } from '../actions'
import { redirect } from './redirect'
import { updatePayment } from './updatePayment'
import { upgrade } from './upgrade'

export function* upgradePlanSaga() {
  yield all([
    takeEvery(UpgradePlanActions.upgrade, upgrade),
    takeEvery(UpgradePlanActions.redirect, redirect),
    takeEvery(UpgradePlanActions.updatePayment, updatePayment),
  ])
}
